import { motion, useReducedMotion } from 'framer-motion';
import PropTypes from 'prop-types';

import * as Styled from './UserResponse.style';

/**
 * A component for displaying user messages in chat bubble format
 * @param {object} props - Component props
 * @param {string} props.message - The user message text to display
 * @param {string} [props.size='sm'] - The size of the message text
 * @param {boolean} [props.visible=true] - Whether the message should be visible
 */

const MotionBubble = motion.create(Styled.UserResponseBubble);

function UserResponse({ message, size = 'md', visible = true }) {
  const prefersReducedMotion = useReducedMotion();

  if (!visible) {
    return null;
  }

  return (
    <Styled.UserResponseRoot>
      <MotionBubble
        animate={{ opacity: 1, scale: 1, x: 0 }}
        initial={{ opacity: 0, scale: 0.8, x: 20 }}
        transition={{ duration: prefersReducedMotion ? 0 : 0.2, ease: 'easeOut' }}
      >
        <Styled.UserResponseText size={size}>{message}</Styled.UserResponseText>
      </MotionBubble>
    </Styled.UserResponseRoot>
  );
}

UserResponse.propTypes = {
  message: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  visible: PropTypes.bool
};

export default UserResponse;
